import { IDmChuyenNganh } from "../../../model/respone/category/IDmChuyenNganh";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDmChuyenNganhActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IDmChuyenNganh[],
  LOAD_ERRR: "",

  SHOW_EDIT_MODAL: {} as IDmChuyenNganh | undefined,
  CLOSE_EDIT_MODAL: undefined,

  SAVE_START: {} as IDmChuyenNganh,
  SAVE_SUCCESS: undefined,
  SAVE_ERRR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERRR: "",
  CHANGE_NGANH_ID_FILTER: 0
};
export const eDmChuyenNganhActionIds = generateActionTypeIds(
  eDmChuyenNganhActionsObj,
  "CHUYEN_NGANH"
);
export type IDmChuyenNganhActionTypes = IGenericActionType<
  typeof eDmChuyenNganhActionsObj,
  "CHUYEN_NGANH"
>;
